// ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { ThemeProvider as MUIThemeProvider } from "@mui/material/styles";
import {LightTheme,  DarkTheme} from "./AppTheme";
// import Apptheme from "./AppTheme";

const ThemeContext = createContext();

export const useCustomTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(
    localStorage?.getItem("themeMode") ?? "light"
  );

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(mode === "light" ? "dark" : "light");
    root.classList.add(mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
    localStorage?.setItem("themeMode", mode === "light" ? "dark" : "light");
  };

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <MUIThemeProvider theme={mode === "light" ? LightTheme : DarkTheme}>
      {/* <MUIThemeProvider theme={Apptheme}>*/}
      {children}</MUIThemeProvider>
    </ThemeContext.Provider>
  );
};
